<template>
  <div id="studentProjectWordDetail">
    <studentProjectWord
      v-if="isupload == 0"
      :wordData="wordData"
      :reversedMessage="reversedMessage"
    />
    <studentProjectWordShow
      ref="myChild"
      v-if="isupload != 0 || downloadDig"
      :downWordData="downWordData"
      :reversedMessage="reversedMessage"
    />
    <div
      style="
        width: 500px;
        margin: 20px auto;
        display: flex;
        justify-content: space-between;
      "
    >	
			<el-button
        style="width: 140px; margin: 20px auto"
        @click="downloadWordDig = true"
        type="primary"
        >下载文档(Word)</el-button
      >
      <el-button
        style="width: 140px; margin: 20px auto"
        @click="downloadDig = true"
        type="primary"
        >下载文档(PDF)</el-button
      >
      <el-button
        style="width: 120px; margin: 20px auto"
        @click="test"
        type="primary"
        v-if="isupload == 0"
        >立即修改</el-button
      >
    </div>
    <!-- 立即修改开始 -->
    <el-dialog
      title="立即修改"
      :visible.sync="updatedWordDig"
      width="600px"
      class="pageSubmitData"
    >
      <div class="deleteContent">确定提交修改?</div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="updatedWord" class="AllDialogBtn"
          >确认</el-button
        >
        <el-button @click="updatedWordDig = false" class="AllDialogBtn"
          >取消</el-button
        >
      </span>
    </el-dialog>
    <!-- 立即修改结束-->

    <!-- 下载文档开始 -->
    <el-dialog
      title="下载文档(PDF)"
      :visible.sync="downloadDig"
      width="600px"
      class="pageSubmitData"
    >
      <div class="deleteContent">确定下载文档?</div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="downloadPDFFile" class="AllDialogBtn"
          >确认</el-button
        >
        <el-button @click="downloadDig = false" class="AllDialogBtn"
          >取消</el-button
        >
      </span>
    </el-dialog>

		<el-dialog
      title="下载文档(Word)"
      :visible.sync="downloadWordDig"
      width="600px"
      class="pageSubmitData"
    >
      <div class="deleteContent">确定下载文档?</div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="downloadWordFile" class="AllDialogBtn"
          >确认</el-button
        >
				<!-- <el-button type="primary" @click="downloadWord2" class="AllDialogBtn"
          >确认2</el-button
        > -->
        <el-button @click="downloadWordDig = false" class="AllDialogBtn"
          >取消</el-button
        >
      </span>
    </el-dialog>
    <!-- 下载文档结束-->
  </div>
</template>
      
    <script>
import { getNowDate } from "@/components/tool/Date.js";
import { getWord } from "@/components/tool/getWord";
import studentProjectWord from "./studentProjectWord.vue";
import studentProjectWordShow from "./studentProjectWordShow.vue";
import { downloadPDF } from "@/components/tool/pdf";

export default {
  components: { studentProjectWord, studentProjectWordShow },
  data() {
    return {
      isupload: 1,
      DepartmentData: [], //部门学院
      downloadDig: false, //下载文档对话框
			downloadWordDig:false,
      updatedWordDig: false, //立即修改对话框
      downWordData: {
        applicationDate: getNowDate(1), //申请日期
        projectName: "",
        radio: "",
        checkList: [],
        schoolRadio: [],
        applyParsonRadio: [],
        applyParsonName: "",
        college: "",
        tel: "",
        beginTime: "",
        endTime: "",
        studentS: [
          { name: "", collage: "", work: "" },
          { name: "", collage: "", work: "" },
          { name: "", collage: "", work: "" },
          { name: "", collage: "", work: "" },
          { name: "", collage: "", work: "" },
          { name: "", collage: "", work: "" },
        ],
        teacherS: [
          { name: "", collage: "", work: "" },
          { name: "", collage: "", work: "" },
        ],
        brief: "",
        introduce: {
          back: "",
          innovate: "",
          path: "",
          scene: "",
          worth: "",
          team: "",
          cost: "",
          expectResults: "",
          expectResultsTeacher: "",
          expectConversion: "",
          plan: "",
        },
        total: 0,
        fund: {
          device: "",
          Material: "",
          processing: "",
          APPRAISAL: "",
          Collaboration: "",
          Transaction: "",
          activities: "",
          entery: "",
        },
      },
      wordData: {
        applicationDate: getNowDate(1), //申请日期
        projectName: "",
        radio: "",
        checkList: [],
        schoolRadio: [],
        applyParsonRadio: [],
        applyParsonName: "",
        college: "",
        tel: "",
        beginTime: "",
        endTime: "",
        studentS: [
          { name: "", collage: "", work: "" },
          { name: "", collage: "", work: "" },
          { name: "", collage: "", work: "" },
          { name: "", collage: "", work: "" },
          { name: "", collage: "", work: "" },
          { name: "", collage: "", work: "" },
        ],
        teacherS: [
          { name: "", collage: "", work: "" },
          { name: "", collage: "", work: "" },
        ],
        brief: "",
        introduce: {
          back: "",
          innovate: "",
          path: "",
          scene: "",
          worth: "",
          team: "",
          cost: "",
          expectResults: "",
          expectResultsTeacher: "",
          expectConversion: "",
          plan: "",
        },
        total: 0,
        fund: {
          device: "",
          Material: "",
          processing: "",
          APPRAISAL: "",
          Collaboration: "",
          Transaction: "",
          activities: "",
          entery: "",
        },
      },
    };
  },
  methods: {
    getText(value) {
      //电话验证
      let verify =
        /^(?:(?:\+|00)86)?1(?:(?:3[\d])|(?:4[5-79])|(?:5[0-35-9])|(?:6[5-7])|(?:7[0-8])|(?:8[\d])|(?:9[189]))\d{8}$/; //获取正则表达式 存放到verify变量中
      let result = verify.test(value.trim()); //判断输入框内容是否符合 正则表达式
      if (!result) return this.$message.error("请输入正确联系号码格式");
    },
    addTeacher() {
      //添加老师
      // if (this.wordData.teacherS.length >= 3)
      //   return this.$message.error("指导老师最多三人");
      this.wordData.teacherS.push({ name: "", collage: "", work: "" });
    },
    DelTeacher(index) {
      //删除老师
      this.wordData.teacherS.splice(index, 1);
    },
    addStudent() {
      //添加学生
      this.wordData.studentS.push({ name: "", collage: "", work: "" });
    },
    DelStudent(index) {
      //删除学生
      this.wordData.studentS.splice(index, 1);
    },
    getProjectDepartmentData() {
      //获取项目立项申请基础信息页面所在部门数据
      this.ajax
        .post(this.$store.state.api + "/SelectAllDepartment", {
          uid: this.$store.state.userInfo.userid,
        })
        .then(
          (res) => {
            this.DepartmentData = res.data[0];
          },
          (err) => {
            console.log(err);
          }
        );
    },
    getData() {
      let param = {
        uid: this.$store.state.userInfo.userid,
        cid: this.$route.query["pid"],
      };

      this.ajax.get(this.$store.state.api + "/studentProjectData", param).then(
        (res) => {
          let data = res.data[0][0];
          console.log(data);
          this.wordData.projectName = data.title;
          this.wordData.radio = data.typeName;
          this.wordData.checkList = JSON.parse(data.multiSelectProject);
          this.wordData.schoolRadio = JSON.parse(data.schoolRemould);
          this.wordData.applyParsonRadio = JSON.parse(data.projectApplyperson);
          this.wordData.applyParsonName = data.pro_leader;
          this.wordData.college = data.classid;
          this.wordData.tel = data.phone;
          this.wordData.beginTime = data.bTime;
          this.wordData.endTime = data.eTime;
          this.wordData.studentS = JSON.parse(data.course_student);
          this.wordData.teacherS = JSON.parse(data.course_teacher);
          this.wordData.brief = data.brief;
          this.wordData.introduce = JSON.parse(data.chapters);
          this.wordData.fund = JSON.parse(data.money);
          this.downWordData = {
            ...this.wordData,
            ...{ etime: data.eTime, btime: data.bTime, dp: data.className },
          };
          this.isupload = data["isupload"];
          console.log(this.downWordData);
        },
        (err) => {
          console.log(err);
        }
      );
    },
    test() {
      //验证
      const cEmpty = /^\s*$/g;
      for (let i in this.wordData) {
        // console.log(this.wordData[i],i);
        switch (i) {
          case "projectName":
            if (cEmpty.test(this.wordData[i])) {
              this.$message.error("请输入项目名称");
              // this.$refs.projectName.style.background='rgb(236, 141, 141)'
              // setTimeout(() => {
              //   this.$refs.projectName.style.background='#ffffff'
              // }, 2000);
              document
                .querySelector("#projectName")
                .scrollIntoView({ behavior: "smooth" });
              return false;
            }
            break;
          case "radio":
            if (cEmpty.test(this.wordData[i])) {
              this.$message.error("请选择项目分组");
              document
                .querySelector("#radio")
                .scrollIntoView({ behavior: "smooth" });
              return false;
            }
            break;
          // case "checkList":
          //   if (this.wordData[i].length == 0) {
          //     this.$message.error("优先支持项目");
          //     document
          //       .querySelector("#checkList")
          //       .scrollIntoView({ behavior: "smooth" });
          //     return false;
          //   }
          //   break;
          // case "schoolRadio":
          //   if (cEmpty.test(this.wordData[i])) {
          //     this.$message.error("请选择美丽校园改造项目");
          //     document
          //       .querySelector("#schoolRadio")
          //       .scrollIntoView({ behavior: "smooth" });
          //     return false;
          //   }
          //   break;
          case "applyParsonRadio":
            if (cEmpty.test(this.wordData[i])) {
              this.$message.error("请选择项目申请人");
              document
                .querySelector("#applyParsonRadio")
                .scrollIntoView({ behavior: "smooth" });
              return false;
            }
            break;
          case "applyParsonName":
            if (cEmpty.test(this.wordData[i])) {
              this.$message.error("请填写申请人姓名");
              document
                .querySelector("#applyParsonName")
                .scrollIntoView({ behavior: "smooth" });
              return false;
            }
            break;
          case "college":
            if (cEmpty.test(this.wordData[i])) {
              this.$message.error("请选择所在学院");
              document
                .querySelector("#applyParsonName")
                .scrollIntoView({ behavior: "smooth" });
              return false;
            }
            break;
          case "tel":
            if (cEmpty.test(this.wordData[i])) {
              this.$message.error("请填写联系方式");
              document
                .querySelector("#applyParsonName")
                .scrollIntoView({ behavior: "smooth" });
              return false;
            }
            break;
          case "beginTime":
            if (cEmpty.test(this.wordData[i])) {
              this.$message.error("请选择项目起始时间");
              document
                .querySelector("#beginTime")
                .scrollIntoView({ behavior: "smooth" });
              return false;
            }
            break;
          case "endTime":
            if (cEmpty.test(this.wordData[i])) {
              this.$message.error("请选择计划完成时间");
              document
                .querySelector("#beginTime")
                .scrollIntoView({ behavior: "smooth" });
              return false;
            }
            break;
          // case "studentS":
          //   let snum = 0;
          //   this.wordData[i].forEach((item) => {
          //     if (cEmpty.test(item["name"])) snum++;
          //     // for(let j in item){
          //     //   if(cEmpty.test(item[j])){
          //     //     snum++;
          //     //   }
          //     // }
          //   });
          //   if (snum > 0) {
          //     this.$message.error("学生姓名请不要留空");
          //     document
          //       .querySelector("#studentS")
          //       .scrollIntoView({ behavior: "smooth" });
          //     return false;
          //   }
          //   // }
          //   break;
          // case "teacherS":
          //   let num = 0;
          //   this.wordData[i].forEach((item) => {
          //     if (cEmpty.test(item["name"])) num++;
          //     // for(let j in item){
          //     //   if(cEmpty.test(item[j])){
          //     //     num++;
          //     //   }
          //     // }
          //   });
          //   if (num > 0) {
          //     this.$message.error("老师姓名请不要留空");
          //     document
          //       .querySelector("#teacherS")
          //       .scrollIntoView({ behavior: "smooth" });
          //     return false;
          //   }
          //   break;
          // case 'brief':
          //     if (cEmpty.test(this.wordData[i])) {
          //       this.$message.error('请填写项目简介')
          //       // this.$refs.brief.style.background='rgb(236, 141, 141)'
          //       // setTimeout(() => {
          //       //   this.$refs.brief.style.background='#ffffff'
          //       // }, 2000);
          //       document.querySelector('#brief').scrollIntoView({ behavior: "smooth" });
          //       return false
          //     }
          // break;
          case "fund":
            let mon =
              this.wordData.fund.device * 1 +
              this.wordData.fund.Material * 1 +
              this.wordData.fund.processing * 1 +
              this.wordData.fund.APPRAISAL * 1 +
              this.wordData.fund.Collaboration * 1 +
              this.wordData.fund.Transaction * 1 +
              this.wordData.fund.activities * 1 +
              this.wordData.fund.entery * 1;
            if (mon == 0) {
              document
                .querySelector("#fund")
                .scrollIntoView({ behavior: "smooth" });
              return this.$message.error("请输入经费");
            }
            break;
        }
      }
      this.wordData["total"] =
        this.wordData.fund.device * 1 +
        this.wordData.fund.Material * 1 +
        this.wordData.fund.processing * 1 +
        this.wordData.fund.APPRAISAL * 1 +
        this.wordData.fund.Collaboration * 1 +
        this.wordData.fund.Transaction * 1 +
        this.wordData.fund.activities * 1 +
        this.wordData.fund.entery * 1;

      this.updatedWordDig = true;
    },
    updatedWord() {
      let param = {
        uid: this.$store.state.userInfo.userid, //用户ID
        cid: this.$route.query["pid"],
        tid: "5e21b204-c206-11ed-a4cd-509a4c5b67cf", //特色创客空间建设项目分类ID
        tit: this.wordData["projectName"], //项目名称
        radio: this.wordData["radio"], //项目分组
        checkList: JSON.stringify(this.wordData["checkList"]), //优先支持项目
        schoolRadio: JSON.stringify(this.wordData["schoolRadio"]), //美丽校园改造项目
        applyParsonRadio: JSON.stringify(this.wordData["applyParsonRadio"]), //项 目 申 请 人
        applyParsonName: this.wordData["applyParsonName"], //申请人姓名
        coid: this.wordData["college"], //学院ID,
        tel: this.wordData["tel"], //联系电话
        beh: this.wordData["beginTime"], //项目开始时间,
        planEnd: this.wordData["endTime"], //计划完成时间,
        cs: JSON.stringify(this.wordData["studentS"]), //学生组,
        ct: JSON.stringify(this.wordData["teacherS"]), //教师组,
        bf: this.wordData["brief"], //项目简介
        introduce: JSON.stringify(this.wordData["introduce"]).replaceAll(/%/g,"%25"), //项目详细
        mon: JSON.stringify(this.wordData["fund"]), //预算经费
        f: this.wordData["total"], //总经费
        apply: this.wordData["applicationDate"], //申请日期
        mem:
          this.wordData["teacherS"].length + this.wordData["studentS"].length,
      };
      console.log(param);
      // return console.log(param);
      this.ajax
        .post(this.$store.state.api + "/updateStudentProjectData", param)
        .then(
          (res) => {
            // console.log(res.data);
            if (res.data) {
              this.updatedWordDig = false;
              return this.$message.success("修改成功");
            } else {
              this.$message.error("修改失败");
            }
          },
          (err) => {
            console.log(err);
          }
        );
    },
		downloadWordFile(){
			getWord(this.downWordData);
			this.downloadWordDig = false;
		},
    downloadPDFFile() {
			// let elementList = this.$refs.myChild.$refs.pdfShow.querySelectorAll('.downImage')
			// elementList.forEach(el => {
			//   let img = el.getElementsByTagName('img');
			// 	for(let i=0;i<img.length;i++){
			// 		img[i].crossOrigin = "*"
			// 	}
			// })
      downloadPDF(
        this.$refs.myChild.$refs.pdfShow,
        "附件2：2023年学生创客项目申报书"
      );
      // this.wordData['total']=this.wordData.fund.facility*1 + this.wordData.fund.materials*1+this.wordData.fund.process*1+ this.wordData.fund.assist*1+this.wordData.fund.authenticate*1+ this.wordData.fund.match*1+this.wordData.fund.activity*1+this.wordData.fund.affair*1
      // return console.log(this.wordData);
			// let elementList = this.$refs.myChild.$refs.pdfShow.querySelectorAll('.downImage')
			// elementList.forEach(el => {
			//   let img = el.getElementsByTagName('img');
			// 	for(let i=0;i<img.length;i++){
			// 		img[i].crossOrigin = "*"
			// 	}
			// })
			// return console.log(elementList)
      // getWord({...this.downWordData,elementList:this.$refs.myChild.$refs.pdfShow.querySelectorAll('.downImage')})
      // getWord(this.downWordData)

      this.downloadDig = false;
    },
		// downloadWord2() {
    //   // downloadPDF(
    //   //   this.$refs.myChild.$refs.pdfShow,
    //   //   "附件2：2023年学生创客项目申报书"
    //   // );
    //   // this.wordData['total']=this.wordData.fund.facility*1 + this.wordData.fund.materials*1+this.wordData.fund.process*1+ this.wordData.fund.assist*1+this.wordData.fund.authenticate*1+ this.wordData.fund.match*1+this.wordData.fund.activity*1+this.wordData.fund.affair*1
    //   // return console.log(this.wordData);
		// 	let elementList = this.$refs.myChild.$refs.pdfShow.querySelectorAll('.downImage')
		// 	elementList.forEach(el => {
		// 	  let img = el.getElementsByTagName('img');
		// 		for(let i=0;i<img.length;i++){
		// 			img[i].crossOrigin = "*"
		// 		}
		// 	})
		// 	// return console.log(elementList)
    //   getWord2({...this.downWordData,elementList:this.$refs.myChild.$refs.pdfShow.querySelectorAll('.downImage')})
    //   // getWord(this.downWordData)

    //   this.downloadDig = false;
    // },
  },
  //小型仪器设备费：device        deviceRemarks
  //材料费：Material             MaterialRemarks
  //测试化验加工费：processing    processingRemarks
  //项目协作费：Collaboration     CollaborationRemarks
  //项目成果鉴定费：APPRAISAL     APPRAISALRemarks
  //参展参赛费：entery            enteryRemarks
  //创客交流活动费：activities    activitiesRemarks
  //知识产权事务费：Transaction   TransactionRemarks
  computed: {
    //经费总合
    reversedMessage: function () {
      return (
        this.wordData.fund.device * 1 +
        this.wordData.fund.Material * 1 +
        this.wordData.fund.processing * 1 +
        this.wordData.fund.Collaboration * 1 +
        this.wordData.fund.APPRAISAL * 1 +
        this.wordData.fund.entery * 1 +
        this.wordData.fund.activities * 1 +
        this.wordData.fund.Transaction * 1
      );
    },
  },
  mounted() {
    this.getProjectDepartmentData();
    this.getData();
    //   console.log(this.$route.query['pid']);
  },
};
</script>
      
    <style lang="less" scoped>
#studentProjectWordDetail {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
}
</style>